module.exports = __webpack_public_path__ + "assets/img/pt-abe95e80.png";